import { render } from "./YPFooter.vue?vue&type=template&id=43ed7968"
import script from "./YPFooter.vue?vue&type=script&lang=js"
export * from "./YPFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__